import {
  formatCompanyTime,
  toCompanyMoment,
  companyNow,
  companyToday,
} from "@/utils/companyTime";

// Global mixin (main.ts). Final-version doc 2026-10-05, problem 4: every
// timestamp is shown in company time (Damascus, fixed UTC+3), never in the
// browser's time zone, so ISO-UTC values and local wall-clock strings agree.
export default {
  methods: {
    formatDate(dateString: any) {
      return formatCompanyTime(dateString, "dddd, MMMM D, YYYY h:mm A");
    },
    formatCompanyTime,
    toCompanyMoment,
    companyNow,
    companyToday,
  },
};
